import styles from "./CTAButton.module.css";

function CTAButton({
    large,
    short,
    href = undefined,
    target = "",
    rel = "noreferrer",
    onClick = () => {},
    children,
}) {
    function handleButtonKey(event) {
        if (event.keyCode === 13) {
            event.preventDefault();
            onClick();
        }
    }
    return href ? (
        <a
            rel={rel}
            target={target}
            href={href}
            className={[
                styles.cta_button,
                large ? styles.large : "",
                short ? styles.short : "",
            ].join(" ")}
        >
            {children}
        </a>
    ) : (
        <button

            onKeyDown={handleButtonKey}
            onClick={onClick}
            className={[
                styles.cta_button,
                large ? styles.large : "",
                short ? styles.short : "",
            ].join(" ")}
        >
            {children}
        </button>
    );
}

export default CTAButton;
